import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferTidalToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.transferTidalToSpotify}
            sections={<PairTransferGuideContent sourceKey="tidal" destKey="spotify" />}
        />
    );
}
